import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import PriorAuthAddEditPopup from './PriorAuthAddEditPopup';
import PriorAuthList from './PriorAuthList';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import { format } from 'date-fns';
import { setSeltSerchPat } from '../../redux/slices/patient/patientSlice';
import { useDispatch } from 'react-redux';
import Button from '../Button';

function MainPriorAuth() {
  const dispatch = useDispatch();
  const [allData, setAllData] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [authId, setAuthId] = useState('');
  const [patientId, setPatientId] = useState('');
  const [reload, setReload] = useState(false);

  const [priorAuthName, setPriorAuthName] = useState('');
  const [chartNumber, setChartNumber] = useState('');
  const [pairSubscriber, setPairSubscriber] = useState('');
  const [serviceCode, setServiceCode] = useState('');
  const [priorAuthStatus, setPriorAuthStatus] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handlePopupOpen = (authId, patientId) => {
    setAuthId(authId);
    setPatientId(patientId);
    setOpenPopup(true);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ManagePriorAuth/authrizationList',
          {
            patientId: '',
            patName: priorAuthName,
            chartNo: chartNumber,
            payerId: pairSubscriber,
            codeId: serviceCode,
            status: priorAuthStatus,
            startDt: startDate && format(startDate, DEFAULT_DATE_FORMATE), //for filter
            endDt: endDate && format(endDate, DEFAULT_DATE_FORMATE),
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    })();
  }, [
    reload,
    priorAuthName,
    chartNumber,
    pairSubscriber,
    serviceCode,
    priorAuthStatus,
    startDate,
    endDate,
  ]);

  return (
    <div id="preauthMaingrid" className="preauth-Maingrid-Pat">
      <div className="c-mid-bdy-hdr clear-top10 flex-sec justify-between item-center">
        <span className="widget-hdr-title bold clear-top">
          Prior Authorization:
        </span>
        <Button
          variant="primary"
          onClick={() => {
            setOpenPopup(true);
            setAuthId('');
            setPatientId('');
            dispatch(setSeltSerchPat({}));
          }}
        >
          Add New
        </Button>
      </div>
      <div className="preauth-Maingrid-Patbdy grid-sec clear-top10">
        <div className="preauth-Maingrid-Pat-hdr grid-sec">
          <div className="preauth-Maingrid-Pat-sbhdr flex-sec">
            <span className="pacolm4">Name/ DOB</span>
            <span className="pacolm5">Chart ID</span>
            <span className="pacolm4">Payor/ Subscriber ID</span>
            <span className="pacolm5">Service Code</span>
            <span className="pacolm5">M</span>
            <span className="pacolm4">Description</span>
            <span className="pacolm5">Authorization Status</span>
            <span className="pacolm5">Start</span>
            <span className="pacolm5">Expire</span>
            <span className="pacolm5">Total</span>
            <span className="pacolm5">Used</span>
            <span className="pacolm5">Remaining</span>
            <span className="pacolm1">Prior authorization#</span>
            <span className="pacolm5">Document</span>
            <span className="pacolm5">Note</span>
            <span className="pacolm5">Status</span>
            <span className="pacolm4">Action</span>
          </div>
          <div className="preauth-Maingrid-Pat-sbhdr flex-sec">
            <span className="pacolm4">
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="priorAuthName"
                name="priorAuthName"
                value={priorAuthName}
                onChange={(e) => setPriorAuthName(e.target.value)}
              />
            </span>
            <span className="pacolm5">
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                id="chartnumber"
                name="chartnumber"
                value={chartNumber}
                onChange={(e) => setChartNumber(e.target.value)}
              />
            </span>
            <span className="pacolm4">
              <select
                className="inpt-width-nw"
                id="pairsubscriber"
                name="pairsubscriber"
                value={pairSubscriber}
                onChange={(e) => setPairSubscriber(e.target.value)}
              >
                <option value="">Select</option>
                {allData?.payerListArr &&
                  allData?.payerListArr.map((item, i) => (
                    <option key={i} value={item?.payer_id}>
                      {item?.payerName}
                    </option>
                  ))}
              </select>
            </span>
            <span className="pacolm5">
              <select
                className="inpt-width-nw"
                id="servicecode"
                name="servicecode"
                value={serviceCode}
                onChange={(e) => setServiceCode(e.target.value)}
              >
                <option value="">Select</option>
                {allData?.serviceListArr &&
                  allData?.serviceListArr.map((item, i) => (
                    <option key={i} value={item?.codeId}>
                      {item?.procCode}
                    </option>
                  ))}
              </select>
            </span>
            <span className="pacolm5">&nbsp;</span>
            <span className="pacolm4">&nbsp;</span>
            <span className="pacolm5">
              <select
                className="inpt-width-nw"
                id="priorAuthStatus"
                name="priorAuthStatus"
                value={priorAuthStatus}
                onChange={(e) => setPriorAuthStatus(e.target.value)}
              >
                <option value="">Select</option>
                {allData?.status &&
                  allData?.status.map((item, i) => (
                    <option key={i} value={item?.id}>
                      {item?.val}
                    </option>
                  ))}
              </select>
            </span>
            <span className="pacolm5">
              <ReactDatePicker
                id="gridstartdate"
                name="gridstartdate"
                onChange={(date) => setStartDate(date || null)}
                className="inpt-width-nw"
                selected={startDate}
                dateFormat={DEFAULT_DATE_FORMATE}
                placeholderText="mm-dd-yyyy"
                isClearable
              />
            </span>
            <span className="pacolm5">
              <ReactDatePicker
                id="gridenddate"
                name="gridenddate"
                onChange={(date) => setEndDate(date || null)}
                className="inpt-width-nw"
                selected={endDate}
                dateFormat={DEFAULT_DATE_FORMATE}
                placeholderText="mm-dd-yyyy"
                isClearable
              />
            </span>
            <span className="pacolm5">&nbsp;</span>
            <span className="pacolm5">&nbsp;</span>
            <span className="pacolm5">&nbsp;</span>
            <span className="pacolm1">&nbsp;</span>
            <span className="pacolm5">&nbsp;</span>
            <span className="pacolm5">&nbsp;</span>
            <span className="pacolm5">&nbsp;</span>
            <span className="pacolm4">&nbsp;</span>
          </div>
        </div>
        <div className="preauth-Maingrid-Pat-sb-bdy qgrid-sec">
          {allData?.authList &&
            allData?.authList.map((item, i) => (
              <div
                key={item?.authId}
                className={
                  i % 2 === 0
                    ? 'preauth-Maingrid-Pat-bdy-rw flex-sec alt-rw'
                    : 'preauth-Maingrid-Pat-bdy-rw flex-sec'
                }
              >
                <PriorAuthList
                  item={item}
                  handlePopupOpen={handlePopupOpen}
                  handleReload={() => setReload(!reload)}
                />
              </div>
            ))}
        </div>
      </div>
      {openPopup && (
        <PriorAuthAddEditPopup
          authId={authId}
          patientId={patientId}
          handleClose={() => setOpenPopup(false)}
          handleReload={() => setReload(!reload)}
          fromMainAuth={true}
        />
      )}
    </div>
  );
}

export default MainPriorAuth;
